import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-bottom">
        <p>© 2026 TheaMou & MeaDea by Theo. All rights reserved.</p>
        <p className="footer-tagline">Φως του Αληθινού · The True Light</p>
      </div>
    </footer>
  );
};

export default Footer;
